import React from 'react';
import { useTranslation } from 'react-i18next';

type CurrencyProps = {
    value?: number,
    currency?: string,
}

const Currency = ({ value, currency = 'jpy' }: CurrencyProps) => {
    const { i18n } = useTranslation();

    return <>{i18n.format(value || 0, 'currency', i18n.language, {currency})}</>
};

export default Currency;
